// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__BZ7PJ","window":"style_window__khkKd","close":"style_close__8Sx5u","content":"style_content__BZX3m"};